export enum UserStatus {
	ACTIVE = "AC",
	BLOCKED = "BL",
}

export const UserStatusList = [
	"AC", "BL"
];
